import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Debounced call to a /decide/* endpoint. Returns null until enough text is typed.
export default function useJevSuggest(endpoint, payload, enabled = true, delay = 700) {
  const [suggestion, setSuggestion] = useState(null);
  const [loading, setLoading] = useState(false);
  const seq = useRef(0);
  const key = JSON.stringify(payload);

  useEffect(() => {
    if (!enabled) { setSuggestion(null); return undefined; }
    const id = ++seq.current;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await axios.post(`${API_URL}/decide/${endpoint}`, payload);
        if (seq.current === id) setSuggestion(res.data);
      } catch {
        if (seq.current === id) setSuggestion(null);
      } finally {
        if (seq.current === id) setLoading(false);
      }
    }, delay);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, key, enabled, delay]);

  return { suggestion, loading };
}
